export default "__VITE_ASSET__I$6fHInH__"